require('./helpers/bundle-manifest').register(JSON.parse("{\"OtNIN\":\"index.50721730.js\",\"7zBd3\":\"RalphBalson.cba1048d.png\"}"));